import React, { Component } from "react";
import { connect } from "react-redux";
import {
  FormInput,
  ActionWithPlus,
  ProjectListHeader,
  RadioButton,
} from "../../../components";
import { back, push } from "../../../actions/nav-actions";
import {
  fetchResourcesAndLimitations,
  putResourcesAndLimitations,
  deleteProjectResource,
} from "../../../api";
import { notify, getDictionary } from "../../../utils";

const radio_props = [
  { label: "Yes", value: 0 },
  { label: "No", value: 1 },
];

class EvaluateContext extends Component {
  state = {
    project: {},
    is_loading: false,
    error: undefined,
    data: {},
  };
  constructor(props) {
    super(props);
    this.request = this.request.bind(this);
    this.getParams = this.getParams.bind(this);
    this.client = getDictionary(props.dictionary);
    this.getText = this.getText.bind(this);
  }
  getText(tag, category = "resources_and_limitations") {
    return this.client.get(category, tag);
  }
  getParams() {
    return this.props.match.params || {};
  }
  componentDidMount() {
    this.loadData();
  }
  loadData() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchResourcesAndLimitations(
        this.props.user.token,
        params.organization,
        params.code
      )
        .then((data) => this.setState({ is_loading: false, data }))
        .catch((err) => this.setState({ is_loading: false, error: err }));
    });
  }
  request() {
    const params = this.getParams();
    putResourcesAndLimitations(
      this.props.user.token,
      params.organization,
      params.code,
      {
        ...this.state.data,
      }
    )
      .then((data) => notify("Update informations", "Successfully updated!"))
      .catch((err) => notify("Error", err.message, "error"));
  }
  onRemove(resource) {
    if (window.confirm("Did you have sure about delete this Resource?")) {
      const params = this.getParams();
      deleteProjectResource(
        this.props.user.token,
        params.organization,
        params.code,
        resource._id
      )
        .then((data) => {
          this.loadData();
        })
        .catch((err) => this.setState({ is_loading: false, error: err }));
    }
  }
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>;
    if (!this.state.data.resources || this.state.is_loading)
      return <span>Loading data...</span>;

    let { resources, questions, options } = this.state.data;

    return (
      <React.Fragment>
        <ProjectListHeader title="DEFINE RESOURCES" />
        <div>
          <p>{this.getText("description")}</p>
          <div>
            <p>Resources:</p>
            {options.resources.map((resource, index) => {
              return (
                <Resource
                  onRemove={() => {
                    this.onRemove(resource);
                  }}
                  key={index}
                  resource={resource}
                />
              );
            })}
          </div>

          <ActionWithPlus
            onClick={() => {
              this.props.push(
                `/projects/${this.props.match.params.organization}/${this.props.match.params.code}/resources#resources-and-limitations`
              );
            }}
            label="Add resource"
          />
        </div>

        <ProjectListHeader title="GUIDING QUESTIONS" />
        <div>
          <p>{this.getText("limitations_question")}</p>
          <FormInput
            value={resources.questions.limitations}
            onChange={(text) => {
              let { resources } = this.state.data;
              resources.questions.limitations = text;
              this.setState({ resources });
            }}
            placeholder=""
          />

          <p>{this.getText("responsible_question")}</p>
          <FormInput
            value={resources.questions.responsible}
            onChange={(text) => {
              let { resources } = this.state.data;
              resources.questions.responsible = text;
              this.setState({ resources });
            }}
            placeholder=""
          />

          <p>{this.getText("knowledge_question")}</p>
          <FormInput
            value={resources.questions.knowledge}
            onChange={(text) => {
              let { resources } = this.state.data;
              resources.questions.knowledge = text;
              this.setState({ resources });
            }}
            placeholder=""
          />

          {/** <div>
            {questions.map((question, index) => {
              return (
                <div key={index}>
                  <p>Question:</p>
                  <FormInput
                    value={question.description}
                    onChange={(value) => {
                      let { questions } = this.state.data;
                      questions[index].description = value;
                      this.setState({
                        data: {
                          ...this.state.data,
                          questions
                        }
                      });
                    }}
                    placeholder="" />
                  <p>Answer:</p>
                  <FormInput
                    value={question.value}
                    onChange={(value) => {
                      let { questions } = this.state.data;
                      questions[index].value = value;
                      this.setState({
                        data: {
                          ...this.state.data,
                          questions
                        }
                      });
                    }}
                    placeholder="" />
                </div>
              )
            })}
          </div>

          <ActionWithPlus
            onClick={() => {
              this.props.push(`/projects/${this.props.match.params.organization}/${this.props.match.params.code}/questions/resources-and-limitations`)
            }}
            label="Add question" />
          **/}

          <div style={{ marginTop: 16 }}>
            <p>{this.getText("sufficiency_question")}</p>
            <RadioButton
              data={radio_props}
              formHorizontal={true}
              style={{ marginTop: 16 }}
              initial={resources.questions.sufficiency ? 0 : 1}
              onChange={(value) => {
                let { resources } = this.state.data;
                resources.questions.sufficiency = value === 0;
                this.setState({
                  data: { ...this.state.data, resources },
                });
              }}
            />
          </div>
        </div>

        <button
          className="btn btn-info"
          onClick={this.request.bind(this)}
          style={{ marginTop: 24, marginBottom: 24 }}
        >
          SAVE
        </button>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.localStorage,
  user: state.authReducer.user,
});

const mapDispatchToProps = (dispatch) => ({
  back() {
    dispatch(back());
  },
  push(routeName) {
    dispatch(push(routeName));
  },
});

function Resource(props) {
  console.log("chama", props.resource);
  return (
    <div style={{ borderTop: "1px solid #CCC", padding: "16px" }}>
      <span>{props.resource.name}</span>
      <br />
      <button
        style={{
          border: 0,
          paddingLeft: 0,
          backgroundColor: "transparent",
          color: "#c51e48",
        }}
        onClick={() => props.onRemove(props.resource)}
      >
        Remove
      </button>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContext);



// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/ResourcesAndLimitationsFormularies.js